import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import M3Button from "./M3Button";
import M3Menu from "./M3Menu";
import styles from "./m3.module.css";

/**
 * Primary action with a dropdown of related options (M3 split button).
 *
 * @param {string} label - main button text
 * @param {function} onClick - main action
 * @param {Array} options - M3Menu items
 * @param {string} menuLabel - aria-label for the dropdown toggle
 */
const SplitButton = ({ label, icon, onClick, options = [], variant = "filled", size = "md", menuLabel, disabled = false }) => {
  const { t } = useTranslation();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.split} ref={anchorRef}>
      <M3Button variant={variant} size={size} icon={icon} onClick={onClick} disabled={disabled} className={styles.splitMain}>
        {label}
      </M3Button>
      <M3Button
        variant={variant}
        size={size}
        className={styles.splitToggle}
        onClick={() => setOpen((o) => !o)}
        aria-label={menuLabel || t("More options")}
        aria-haspopup="menu"
        aria-expanded={open}
        disabled={disabled}
        icon={<KeyboardArrowDownIcon className={`${styles.chevron} ${open ? styles.chevronOpen : ""}`} />}
      />
      <M3Menu anchorEl={anchorRef.current} open={open} onClose={() => setOpen(false)} items={options} />
    </div>
  );
};

export default SplitButton;
